import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import Avatar from 'material-ui/Avatar';
import {Link} from 'react-router-dom';
import styles from './BlockApplication.css';
import defaultAppPicture from '../../../resources/images/application/Application2.svg';
import AdminService from '../../../services/admin';
import {SUPER_ADMIN} from '../../../services/admin';
import {APPLICATION_PAGE} from "../../../constants/routes";

class Application extends React.Component {

    static propTypes = {
        app: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    state = {
        shadow: 1
    };

    onMouseOver = () => this.setState({shadow: 2});
    onMouseOut = () => this.setState({shadow: 1});

    render() {
        let image;
        let selfavatarstyles;
        let selfheaderstyles;
        if (this.props.app.primary_color) {
            selfheaderstyles = {
                ...styles.header,
                backgroundColor: this.props.app.primary_color
            };
            selfavatarstyles = {
                ...styles.avatar,
                backgroundColor: this.props.app.primary_color
            };
        } else {
            selfheaderstyles = {
                ...styles.header
            };
            selfavatarstyles = {
                ...styles.avatar
            };
        }
        if (this.props.app.picture) {
            image = this.props.app.picture;
        } else {
            image = defaultAppPicture;
        }
        return (
            <Link to={APPLICATION_PAGE.replace(':appId', this.props.app.id)}>
                <Paper onMouseOver={this.onMouseOver}
                       onMouseOut={this.onMouseOut}
                       zDepth={this.state.shadow}
                       style={styles.block}>
                    <Paper style={selfheaderstyles} zDepth={0}>
                        <Avatar src={image} size={75} style={selfavatarstyles}/>
                    </Paper>
                <h1 style={styles.title}>{this.props.app.name}</h1>
                    {AdminService.isAuthorized(SUPER_ADMIN, this.props.user) && <p  style={styles.subtitle}>{this.props.app.id}</p>}
                </Paper>
            </Link>
        );
    }
}

export default Application;



// WEBPACK FOOTER //
// src/components/application/BlockApplication/BlockApplication.js